import { useQuery } from '@apollo/client';
import { WelcomeGuide } from 'components/admin/header/WelcomeGuide';
import { SplitGuide } from 'components/admin/visual/SplitGuide';
import {
    GuideByIdQuery,
    GuideByIdQueryVariables
} from 'graphql/query/__generated__/GuideByIdQuery';
import { GUIDES_BY_ID_QUERY } from 'graphql/query/guideQuery';
import { useGuideMutations } from 'hooks/guide/useGuideMutations';
import { useLinkMapAndGuideToUser } from 'hooks/ownership/useLinkMapAndGuideToUser';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { DEFAULT_THEME } from 'static/config/guideThemes';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const GuideLandingGuest = (props: Props): JSX.Element => {
    const guideMutations = useGuideMutations();
    const { getListOfGuides, getTokenForGuideId } = useWorldMapLocalStorage();
    const navigate = useNavigate();
    // const location = useLocation();
    // const localStorage = useWorldMapLocalStorage();
    // const {
    //     state: { loggedUser }
    // } = useContext(GlobalContext);

    // const createdMaps = localStorage.getListOfMaps();
    // const mapIdInCreation = createdMaps[createdMaps.length - 1];
    // const showContinue = !loggedUser && mapIdInCreation;

    useLinkMapAndGuideToUser();

    const guidesListIds = getListOfGuides();

    const guideByIdQuery = useQuery<GuideByIdQuery, GuideByIdQueryVariables>(GUIDES_BY_ID_QUERY, {
        variables: {
            guideId: guidesListIds[0],
            token: getTokenForGuideId(guidesListIds[0])
        },
        skip: guidesListIds.length === 0,
        fetchPolicy: 'network-only'
    });

    // BEGIN - Disable guest page
    useEffect(() => {
        navigate('/login');
    }, []);
    return null;
    // END - Disable guest page

    if (guideByIdQuery.loading) {
        return null;
    }

    const guideId = guideByIdQuery?.data?.guideById?.guideId;

    return (
        <S_GuideLandingGuest className={props.className}>
            <WelcomeGuide
                title={Localization.LANDING_TITLE}
                description={Localization.LANDING_DESCRIPTION}
                items={[
                    Localization.LANDING_ITEM1,
                    Localization.LANDING_ITEM2,
                    Localization.LANDING_ITEM3
                ]}
                color={DEFAULT_THEME.styling.matchColor}
                background={DEFAULT_THEME.headerImageUrl}
            />
            <SplitGuide
                title={Localization.GUIDES}
                description={Localization.GUIDES_DESC}
                button={
                    guideByIdQuery.data
                        ? {
                              text: Localization.EDIT_GUIDE_NO_LOGIN,
                              iconName: 'pencil',
                              onClick: () => {
                                  navigate(`/admin/${guideId}`);
                              }
                          }
                        : {
                              text: Localization.CREATE_GUIDE_NO_LOGIN,
                              iconName: 'plus',
                              onClick: () => {
                                  guideMutations
                                      .create({
                                          title: Localization.NEW_GUIDE_TITLE,
                                          welcomeMessage: Localization.NEW_GUIDE_MESSAGE,
                                          visualStyleId: 'default',
                                          logoUrl:
                                              'https://dvtqxks0zalev.cloudfront.net/766dcd1e-e9fd-400e-8b0a-7f761842f2a4.png'
                                      })
                                      .then((result) => {
                                          const guideId = result.data.g_createGuide.guide.guideId;
                                          navigate(`/admin/${guideId}`);
                                      });
                              }
                          }
                }
            />
            {/* <SplitGuide
                title={Localization.INTERACTIVE_MAPS}
                description={Localization.INTERACTIVE_MAPS_DESC}
                button={
                    showContinue
                        ? {
                              text: Localization.EDIT_MAP_NO_LOGIN,
                              iconName: 'pencil',
                              onClick: () => {
                                  navigate(`/minute/${mapIdInCreation}`);
                              }
                          }
                        : {
                              text: Localization.CREATE_MAP_NO_LOGIN,
                              iconName: 'plus',
                              onClick: () => {
                                  navigate('/create');
                              }
                          }
                }
            /> */}
        </S_GuideLandingGuest>
    );
};

const S_GuideLandingGuest = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 100px 0;
`;
